import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
var AiHtmlView = /** @class */ (function (_super) {
    tslib_1.__extends(AiHtmlView, _super);
    function AiHtmlView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.html = "";
        return _this;
    }
    AiHtmlView.prototype.created = function () {
        this.$watch("url", this.load);
        this.load();
    };
    AiHtmlView.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var html, base;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.url) {
                            this.html = "";
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, axios.create({ baseURL: "/" }).get(this.url)];
                    case 1:
                        html = (_a.sent()).data || "";
                        base = this.url.match(/.*\//)[0];
                        html = html.replace(/src\s*=\s*(["'])\s*(.*?)\1/gi, function (m, g1, src) {
                            if (!src.match(/^\/|:\/\//))
                                src = base + src;
                            return "src=\"" + src + "\"";
                        });
                        this.html = html;
                        this.$emit("load");
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: String, default: "" }),
        tslib_1.__metadata("design:type", String)
    ], AiHtmlView.prototype, "url", void 0);
    AiHtmlView = tslib_1.__decorate([
        Component
    ], AiHtmlView);
    return AiHtmlView;
}(Vue));
export default AiHtmlView;
